"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.ProductFlightCreateDto = void 0;
var class_validator_1 = require("class-validator");
var product_dto_1 = require("./product.dto");
var class_transformer_1 = require("class-transformer");
var dto_1 = require("../../shared/dto");
var Passenger = (function (_super) {
    __extends(Passenger, _super);
    function Passenger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        class_validator_1.IsIn(['ADULT', 'CHILD', 'INFANT', 'SENIOR', 'STUDENT', 'YOUNG', 'MILITARY']),
        __metadata("design:type", String)
    ], Passenger.prototype, "type");
    return Passenger;
}(dto_1.GuestDto));
var Flight = (function () {
    function Flight() {
    }
    return Flight;
}());
var ProductFlightCreateDto = (function (_super) {
    __extends(ProductFlightCreateDto, _super);
    function ProductFlightCreateDto() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.productCategory = 'FLIGHT';
        return _this;
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['FLIGHT']),
        __metadata("design:type", String)
    ], ProductFlightCreateDto.prototype, "type");
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsIn(['ROUND_TRIP', 'ONE_WAY']),
        __metadata("design:type", String)
    ], ProductFlightCreateDto.prototype, "direction");
    __decorate([
        class_transformer_1.Type(function () { return Passenger; }),
        class_validator_1.ValidateNested({ each: true }),
        __metadata("design:type", Array)
    ], ProductFlightCreateDto.prototype, "passengers");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return Flight; }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", Flight)
    ], ProductFlightCreateDto.prototype, "outboundFlight");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return Flight; }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", Flight)
    ], ProductFlightCreateDto.prototype, "returnFlight");
    return ProductFlightCreateDto;
}(product_dto_1.ProductDto));
exports.ProductFlightCreateDto = ProductFlightCreateDto;
//# sourceMappingURL=product-flight-create.dto.js.map